import React from "react";
import moment from "moment";

import { DataStore, DataActions } from "../../../services/AxoServices";

import { Consumer, withRTKData } from "../../../utilities/LexUtilities";

import AccountingVatView from "./AccountingVatView";
import AccountingVatViewV2 from "./AccountingVatViewV2";

class AccountingVatContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    // Dates are moments
    this.state = {
      settlingVat: false,
      showConfirmationMessage: false,
      settlingStartDate: null,
      settlingEndDate: null,
      settlingAccountId: 0,
      payingVat: false,
      paymentDate: moment(),
      selectedPaymentAccountId: null,
      reportingVat: false,
      reportingPeriod: null,
      vatSubmissionResult: null,
    };

    this.defaultPlan = { accounts: [] };
    this.timeout = null;
  }

  componentDidMount() {
    DataStore.fetchClientPlan();
    DataStore.fetchFiscalYears().then(() => {
      DataStore.fetchVatReport();
    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  mapStoreToProps = (store) => {
    return {
      selectedPlan: store.clientPlan || this.defaultPlan,
      fiscalYears: store.fiscalYears,
      selectedFiscalYearId: store.selectedFiscalYearId,
      vatReportArray: store.vatReportArray,
      vatReport: store.vatReport,
      includeDraft: store.includeDraft,
      userProfile: store.userProfile,
    };
  };

  handleSelectedClient = (selectedClient) => {
    DataStore.setState({
      fiscalYears: null,
    });

    DataStore.setSelectedContact(selectedClient);

    DataStore.fetchClientPlan();
    DataStore.fetchFiscalYears().then(() => {
      DataStore.fetchVatReport();
    });
  };

  onSelectFiscalYear = (fiscalYearId) => {
    DataStore.selectFiscalYear(fiscalYearId);
    DataStore.fetchVatReport();
  };

  onSettleVat = (startDate, endDate) => {
    this.setState({
      settlingVat: true,
      settlingStartDate: startDate || moment().utc(),
      settlingEndDate: endDate || moment().utc(),
    });
  };

  onCancelSettling = () => {
    this.setState({
      settlingVat: false,
      settlingStartDate: null,
      settlingEndDate: null,
    });
  };

  doSettleVat = async (clientId, includeDraft) => {
    let { settlingStartDate, settlingEndDate } = this.state;

    let response = await DataActions.settleVat({
      clientId,
      startDate: settlingStartDate.format(),
      endDate: settlingEndDate.format(),
      filter: includeDraft ? "All" : "Posted",
    });

    if (!!response && !!response.ok) {
      this.setState({
        showConfirmationMessage: true,
        settlingVat: false,
        settlingStartDate: null,
        settlingEndDate: null,
      });
      this.timeout = setTimeout(
        () => this.setState({ showConfirmationMessage: false }),
        3000
      );
      DataStore.fetchVatReport();

      return true;
    }
    return false;
  };

  onPayVat = (startDate, endDate) => {
    this.setState({
      payingVat: true,
      settlingStartDate: startDate || moment(),
      settlingEndDate: endDate || moment(),
      paymentDate: endDate || moment(),
    });
  };

  doPayVat = async (clientId, paymentAccountId) => {
    let { settlingEndDate, paymentDate } = this.state;

    let response = await DataActions.payVat({
      clientId,
      paymentAccountId,
      settlingDate: settlingEndDate.format(),
      paymentDate: paymentDate.format(),
    });

    if (!!response && !!response.ok) {
      this.setState({
        showConfirmationMessage: true,
        payingVat: false,
        paymentDate: null,
        settlingStartDate: null,
        settlingEndDate: null,
      });
      this.timeout = setTimeout(
        () => this.setState({ showConfirmationMessage: false }),
        3000
      );
      DataStore.fetchVatReport();

      return true;
    }
    return false;
  };

  onCancelPayment = () => {
    this.setState({ payingVat: false });
    };

  onReportVat = (period) => {
    this.setState({
      reportingVat: true,
      reportingPeriod: period,
      vatSubmissionResult: null,
    });
  };

  onCancelReportingVat = () => {
    this.setState({
      reportingVat: false,
      reportingPeriod: null,
      vatSubmissionResult: null,
    });
  };

  doReportVat = async (clientId) => {
    let {
      startDate,
      endDate,
      afgiftTilsvarBeloeb,
      salgsMomsBeloeb,
      koebsMomsBeloeb,
      euKoebBeloeb,
      euKoebYdelseBeloeb,
      momsEUKoebBeloeb,
      momsEUYdelserBeloeb,
      euSalgVarerBeloeb,
      euSalgYdelseBeloeb,
      ikkeEUSalgVarerBeloeb,
      eksportOmsaetningBeloeb,
      co2AfgiftBeloeb,
      elAfgiftBeloeb,
      gasAfgiftBeloeb,
      kulAfgiftBeloeb,
      olieAfgiftBeloeb,
      vandAfgiftBeloeb,
    } = this.state.reportingPeriod;

    let roundOrUndefined = (value) =>
      value === undefined || value === null ? undefined : Math.round(value);

    let result = await DataActions.reportVat(clientId, {
      periodeFraDato: startDate.format(),
      periodeTilDato: endDate.format(),
      afgiftTilsvarBeloeb: Math.round(afgiftTilsvarBeloeb),
      salgsMomsBeloeb: roundOrUndefined(salgsMomsBeloeb),
      koebsMomsBeloeb: roundOrUndefined(koebsMomsBeloeb),
      euKoebBeloeb: roundOrUndefined(euKoebBeloeb),
      euKoebYdelseBeloeb: roundOrUndefined(euKoebYdelseBeloeb),
      momsEUKoebBeloeb: roundOrUndefined(momsEUKoebBeloeb),
      momsEUYdelserBeloeb: roundOrUndefined(momsEUYdelserBeloeb),
      euSalgVarerBeloeb: roundOrUndefined(euSalgVarerBeloeb),
      euSalgYdelseBeloeb: roundOrUndefined(euSalgYdelseBeloeb),
      ikkeEUSalgVarerBeloeb: roundOrUndefined(ikkeEUSalgVarerBeloeb),
      eksportOmsaetningBeloeb: roundOrUndefined(eksportOmsaetningBeloeb),
      co2AfgiftBeloeb: roundOrUndefined(co2AfgiftBeloeb),
      elAfgiftBeloeb: roundOrUndefined(elAfgiftBeloeb),
      gasAfgiftBeloeb: roundOrUndefined(gasAfgiftBeloeb),
      kulAfgiftBeloeb: roundOrUndefined(kulAfgiftBeloeb),
      olieAfgiftBeloeb: roundOrUndefined(olieAfgiftBeloeb),
      vandAfgiftBeloeb: roundOrUndefined(vandAfgiftBeloeb),
    });

    this.setState({ vatSubmissionResult: result });

    if (!!result.ok && !!result.Success) {
      this.setState({
        showConfirmationMessage: true,
        reportingVat: false,
        reportingPeriod: null,
      });
      this.timeout = setTimeout(
        () => this.setState({ showConfirmationMessage: false }),
        3000
      );
      DataStore.fetchVatReport();

      return true;
    }
    return false;
  };

  onSelectPaymentAccount = (accountId) => {
    this.setState({ selectedPaymentAccountId: accountId });
  };

  onSelectPaymentDate = (selectedDate) => {
    this.setState({ paymentDate: selectedDate });
  };

  onChangeIncludeDraft = (includeDraft) => {
    DataStore.setState({ includeDraft });
    DataStore.fetchVatReport();
  };

  render() {
    let { useDetailedVatView } = this.props;

    if (useDetailedVatView) {
      return (
        <Consumer>
          {(store) => (
            <AccountingVatViewV2
              {...this.mapStoreToProps(store)}
              {...this.props}
              {...this.state}
              handleSelectedClient={this.handleSelectedClient}
              onSelectFiscalYear={this.onSelectFiscalYear}
              onSettleVat={this.onSettleVat}
              onCancelSettling={this.onCancelSettling}
              doSettleVat={this.doSettleVat}
              onPayVat={this.onPayVat}
              onCancelPayment={this.onCancelPayment}
              doPayVat={this.doPayVat}
              onSelectPaymentAccount={this.onSelectPaymentAccount}
              onSelectPaymentDate={this.onSelectPaymentDate}
              onChangeIncludeDraft={this.onChangeIncludeDraft}
              onReportVat={this.onReportVat}
              onCancelReportingVat={this.onCancelReportingVat}
              doReportVat={this.doReportVat}
            />
          )}
        </Consumer>
      );
    }

    return (
      <Consumer>
        {(store) => (
          <AccountingVatView
            {...this.mapStoreToProps(store)}
            {...this.props}
            {...this.state}
            handleSelectedClient={this.handleSelectedClient}
            onSelectFiscalYear={this.onSelectFiscalYear}
            onSettleVat={this.onSettleVat}
            onCancelSettling={this.onCancelSettling}
            doSettleVat={this.doSettleVat}
            onPayVat={this.onPayVat}
            onCancelPayment={this.onCancelPayment}
            doPayVat={this.doPayVat}
            onSelectPaymentAccount={this.onSelectPaymentAccount}
            onSelectPaymentDate={this.onSelectPaymentDate}
            onChangeIncludeDraft={this.onChangeIncludeDraft}
            onReportVat={this.onReportVat}
            onCancelReportingVat={this.onCancelReportingVat}
            doReportVat={this.doReportVat}
          />
        )}
      </Consumer>
    );
  }
}

export default withRTKData(AccountingVatContainer);
